import { render, staticRenderFns } from "./TableDinamis.vue?vue&type=template&id=d908fc4a&"
import script from "./TableDinamis.vue?vue&type=script&lang=js&"
export * from "./TableDinamis.vue?vue&type=script&lang=js&"
import style0 from "./TableDinamis.vue?vue&type=style&index=0&id=d908fc4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports